import { QuestionnaireStatus } from '@/components/decision-tree';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import { useGetQuestionnaire } from '@/queries/questionnaire.queries';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRedirectIfQuestionnaireUncompleted = () => {
  const navigate = useNavigate();
  const { data: userQuestionnaire, isLoading: isLoadingQuestionnaire } = useGetQuestionnaire();
  const questionnaireStatus = userQuestionnaire?.status;

  useEffect(() => {
    if (questionnaireStatus === QuestionnaireStatus.uncompleted && navigate) {
      navigate(ROUTE_DASHBOARD);
    }
  }, [questionnaireStatus, navigate]);

  return { isLoadingQuestionnaire, questionnaireStatus };
};
